import { useCallback, useState } from 'react';

import { Option } from '@/lib/v2/components';

import { useApiManagerService } from '@/src/infrastructure/Protocol/ApiManager/useApiManagerService';

export const useApiKeys = () => {
  const service = useApiManagerService();
  const [apiKeysOptions, setApisKeysOptions] = useState<Option[]>();

  const getApisKeys = useCallback(
    async (apiKeyId: string) => {
      const response = await service.getApiTokens();
      if (response.tokens.length > 0) {
        const groupsMap: Option[] = response.tokens.map((token) => {
          const { apiKeyId, apiKey, name } = token;
          return { id: apiKeyId, value: apiKey, name } as Option;
        });
        setApisKeysOptions(groupsMap);
        return groupsMap.find((group) => group.id === apiKeyId) ?? { id: '', value: '', name: '' };
      } else {
        const response = await service.creteApiTokens('api-integration');
        if (response) await getApisKeys(apiKeyId);
        return { id: '', value: '', name: '' };
      }
    },
    [service]
  );

  return {
    apiKeysOptions: apiKeysOptions || [],
    getApisKeys,
  };
};
